export default "__VITE_ASSET__CyqhVEdx__";